import {
    ACCOUNTS_CHANGE_STATUS_OPEN_MODAL,
    ACCOUNTS_CHANGE_STATUS_CLOSE_MODAL,
    ACCOUNTS_CHANGE_STATUS_REQUEST,
    ACCOUNTS_CHANGE_STATUS_RESULT,
    ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST,
    ACCOUNTS_CHANGE_STATUS_REQUEST_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    account: null,
    schedule: null,
    errorSchedule: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACCOUNTS_CHANGE_STATUS_OPEN_MODAL:
            return { ...state, openModal: true, account: action.payload }
        case ACCOUNTS_CHANGE_STATUS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case ACCOUNTS_CHANGE_STATUS_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_CHANGE_STATUS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_CHANGE_STATUS_REQUEST_RESULT:

            return { ...state, loading: false, schedule: action.payload }

        case CLEAR_REDUX:
            return ["", "ACCOUNTS_CHANGE_STATUS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};